<template>
  <div>
    <v-layout wrap style="display: flex; align-items: center">
      <v-flex xs6 sm7 class="pl-3 pr-3 pt-2 pb-2 font-weight-bold">
        <div class="primary--text body-1">{{ $t('order_no') }}</div>
        <div>
          {{ order.id }}
        </div>
      </v-flex>

      <v-flex xs6 sm5 class="pl-3 pr-3 pt-2 pb-2 text-xs-right">
        <v-chip label outline :color="statusColor"> {{ $t(order.status) }}</v-chip>
      </v-flex>
      <v-flex xs6 sm7 class="pl-3 pr-3 pt-2 pb-2 font-weight-bold">
        <div class="primary--text body-1">{{ $t('shipping_date') }}</div>
        <div>
          <template v-if="order.shipping_date">{{
            order.shipping_date | DateFormat('DD/MM/YYYY HH:mm')
          }}</template>
          <template v-else>-</template>
        </div>
      </v-flex>

      <v-flex xs6 sm5 class="pl-3 pr-3 pt-2 pb-2 text-xs-right">
        <v-btn flat class="ma-0" style="width: 100%" @click="showDetail = !showDetail">
          <em v-if="showDetail" class="fa fa-sort-asc primary-color" aria-hidden="true" />
          <em v-else class="fa fa-sort-desc primary-color" aria-hidden="true" />
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout v-show="showDetail" wrap>
      <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
        <div>
          {{ order.nameaddress | '-' }}
        </div>
      </v-flex>
      <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
        <h4 class="title">{{ $t('Products') }}</h4>
      </v-flex>
      <template v-if="!loading">
        <template v-for="(product, i) in order.productdetail">
          <v-layout :key="`product_${i}`" wrap>
            <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
              <div style="display: flex">
                <img
                  :src="product.photourl"
                  aspect-ratio="1"
                  alt
                  class="grey lighten-2"
                  style="width: 30px; height: 30px"
                />
                <label class="ml-2 primary-color">
                  {{ product.name }}
                  <span style="color: #000"> ({{ product.option }})</span></label
                >
                <label class="ml-2" style="color: #000">x{{ product.quantity }}</label>
              </div>
            </v-flex>
            <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
              <label class="ml-2"> ฿{{ product.price | decimalFormat }}</label>
            </v-flex>
          </v-layout>
        </template>
      </template>
      <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
        <label class="ml-2"> {{ $t('Subtotal') }}</label>
      </v-flex>
      <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
        <label class="ml-2">
          ฿{{ (order.total - (order.shippingcharge ? order.shippingcharge : 0)) | decimalFormat }}
        </label>
      </v-flex>
      <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
        <label class="ml-2"> {{ $t('Shipping fee') }}</label>
      </v-flex>
      <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
        <label class="ml-2"> ฿{{ order.shippingcharge | decimalFormat }}</label>
      </v-flex>
      <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
        <label class="ml-2"> {{ $t('Total') }}</label>
      </v-flex>
      <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">
        <label class="ml-2"> ฿{{ JSON.parse(order.amount) | decimalFormat }}</label>
      </v-flex>
    </v-layout>

    <div>
      <v-btn outline small color="primary" @click="goToOrder">{{ $t('view_detail') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

export default {
  components: {},
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showDetail: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    statusColor() {
      let color = 'primary'
      switch (this.order.status) {
        case 'ordered':
          color = 'warning'
          break
        case 'shipped':
          color = 'success'
          break
        case 'canceled':
          color = 'error'
          break
        case 'paid':
          color = 'secondary'
          break

        default:
          color = 'primary'
          break
      }

      return color
    }
  },
  methods: {
    goToOrder: function () {
      let routeData = this.$router.resolve({
        name: 'template',
        path: '/' + this.currentLang + '/template',
        query: {
          tab: 'ecommerce-order-summary',
          order_id: this.order.id || '',
          order_date: dayjs(this.order.timestamp).format('YYYY-MM-DD') || ''
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/TremendousOrderItem.vue